import { useEffect } from "react";
import LegalPage from "@/components/legal/LegalPage";

export default function RefundPolicy() {
  useEffect(() => {
    document.title = "Refund Policy — Trade Flux";
  }, []);

  return (
    <LegalPage
      eyebrow="Refund Policy"
      title="Refund Policy"
      updated="2026"
    >
      <p className="text-white/70 text-base md:text-lg">
        Thank you for purchasing <strong className="text-white">The 9-to-5 Exit Blueprint</strong>.
      </p>

      <p>
        Because this is a digital product delivered instantly after purchase, all
        sales are considered final. Once access has been granted, refunds are
        generally not available.
      </p>

      <p>
        If you encounter any issues downloading or accessing your files, please{" "}
        <a
          href="mailto:support@trade-flux.com"
          className="text-emerald-400 hover:text-emerald-300 underline underline-offset-4"
        >
          contact us
        </a>
        . We'll work with you to resolve any technical problems as quickly as possible.
      </p>

      <div className="mt-10 rounded-2xl border border-amber-500/20 bg-amber-500/5 p-6 text-sm text-amber-100/75 leading-relaxed">
        <strong className="text-amber-300 font-display font-semibold block mb-2">
          Educational Disclaimer
        </strong>
        This guide is an educational resource designed to help you learn the
        fundamentals of day trading. Individual trading results vary, and the
        purchase of this guide does not guarantee financial success or investment
        returns.
      </div>
    </LegalPage>
  );
}
